/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { Fab } from "@mui/material";
import GpsFixedIcon from "@mui/icons-material/GpsFixed";
import { useGoogleMap } from "@react-google-maps/api";
import { FC, useEffect, useRef } from "react";
import { useUserContext } from "context/UserContext";

export interface ResetMapPositionProps {
  center: google.maps.LatLng | google.maps.LatLngLiteral;
  zoom: number;
}

export const ResetMapPosition: FC<ResetMapPositionProps> = ({
  center,
  zoom,
}) => {
  const map = useGoogleMap();
  const { jobsite } = useUserContext();
  const ref = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (map) {
      const controls = map.controls[google.maps.ControlPosition.RIGHT_BOTTOM];
      if (ref.current) {
        const idx = controls
          .getArray()
          .findIndex((e) => e.id === "map-control-reset-pos-icon");
        if (idx === -1) {
          // not found.
          controls.push(ref.current);
        } else {
          // replace
          controls.setAt(idx, ref.current);
        }
      }
    }
  }, [map]);

  useEffect(() => {
    if (map && jobsite?.jobSiteId) {
      map.setCenter(center);
      map.setZoom(zoom);
    }
  }, [map, jobsite?.jobSiteId, center, zoom]);

  const onClick = () => {
    if (map) {
      map.setZoom(zoom);
      map.setCenter(center);
    }
  };

  return (
    <Fab id="map-control-reset-pos-icon" ref={ref} onClick={onClick}>
      <GpsFixedIcon />
    </Fab>
  );
};
